import { render, staticRenderFns } from "./HumanCapitalAward.vue?vue&type=template&id=3dae162f&"
import script from "./HumanCapitalAward.vue?vue&type=script&lang=js&"
export * from "./HumanCapitalAward.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports